import 'regenerator-runtime/runtime';
import { createSessionCookie, createRefCookie } from '@ltvco/refresh-lib/utils';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import LocationChangeListener from 'components/locationChangeListener/LocationChangeListener';

import App from './App';

import '@ltvco/refresh-lib/dist/lib/style.css';
const prefix = import.meta.env.VITE_PATH_PREFIX;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={prefix}>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <LocationChangeListener />
        <App />
      </QueryParamProvider>
    </BrowserRouter>
  </React.StrictMode>
);

createSessionCookie();
createRefCookie();
